import React, { Component } from "react";
import "react-table/react-table.css";
import "../../tables/reactTable.css";
import ReactTableComponent from "../../tables/ReactTable";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import editicon from "../../../../src/Components/assets/edit.png";
import { getContactImageUrl } from "../../../config";
import { getContactImageUrl2 } from "../../../config";
import {
  campaignContactsTabList,
  campaignContactsTabSelectList,
  campaignContactsExport
} from "../../../Queries";
import swal from "sweetalert";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

import SearchIcon from "../../assets/search.png";
import { TextField, Button, IconButton } from "@material-ui/core";
import { Checkbox } from "pretty-checkbox-react";
import "../CampaignTables.css";
import "../CampaignTabs.css";
import "./CampaignContactsTab.css";
import ExportTo from "./NoOppExcel";
import NoOppTo from "./NoOppTo";
import {
  contacts,
  Profileid,
  plannedDate,
  UpdatefollowUp
} from "../campaignQueries";
import { fetchMethod } from "../../../FetchMethod";
import ContactDetails from "./ContactDetails.js";
import { Drawer } from "@material-ui/core";
//import Photo from "../../assets/photo.png";
const moment = require("moment");
class CampaignContactsTab extends Component {
  constructor(props) {
    super(props);
    this.child = React.createRef();
    this.state = {
      search: "",
      loading: false,
      limit: 0,
      offset: 0,
      searchFlag: false,
      clickToSearch: false,
      campaignContacts: [],
      campaignContactsTableList: [],
      totalCount: 0,
      selectedDate: new Date(),
      fileName: "Contacts",
      Currentstage: [],
      invitationSent: [],
      anchorEl: null,
      show: "",
      openDetails: false,
      columnFilter: "",
      shortfilter: false,
      getData: [],
      getCampaignId: null,
      getCampaignId2: null,
      getCustomer: [],
      contactStatus: null,
      campaignStatus: null,
      contactId: null,
      Row: "",
      ContactDetailsWorkflow: [],
      ContactDetailsMessages: [],
      campStatus: ["All", "Live", "Pause", "Completed"],
      defaultCampStatus: "All",
      contStatus: ["All", "Suspect", "Prospect", "Opportunity"],
      defaultContStatus: "All",
      selected: {},
      selectAll: 0,
      selectedArray: [],
      campaignContactAllSelectedList: [],
      profileid: undefined,
      salesforcetoken: null,
      hubspottoken: null,
      isSearching: false,
      campaignContactsExportData: [],
      clientY: null,
      clientX: null
    };
  }
  componentDidMount() {
    this.ExportData();
    this.setState({ show: false }, () =>
      this.props.detailEdit(this.state.show)
    );
    this.Profile();
  }

  ExportData = () => {
    const filter = this.filter();
    fetchMethod(campaignContactsExport, filter)
      .then(res => res.json())
      .then(res => {
        this.setState({
          campaignContactsExportData: res.data.allContacts.Contacts
        });
      });
  };

  Profile = () => {
    fetchMethod(Profileid(this.props.campaignId))
      .then(res => res.json())
      .then(res => {
        this.setState({
          profileid:
            res.data.Campaigns.customercredentialsIbfk1rel
              .Customerlinkedinprofiles[0].id,
          hubspottoken:
            res.data.Campaigns.customercredentialsIbfk1rel
              .Customerlinkedinprofiles[0].hubspottoken,
          salesforcetoken:
            res.data.Campaigns.customercredentialsIbfk1rel
              .Customerlinkedinprofiles[0].salesforcetoken
        });
      })
      .catch(e => console.log(e));
  };

  emptySelectedArray = () => {
    this.setState({ selectedArray: [], selectAll: false, selected: {} });
  };

  handleDateChange = date => {
    this.setState({
      selectedDate: date
    });
  };

  SetLimit = limit => {
    this.setState({
      limit
    });
  };

  SetOffset = offset => {
    this.setState({ offset });
  };

  setContactsListData = response => {
    let data = response.data.allContacts.Contacts;

    this.setState(
      {
        campaignContacts: data,
        totalCount: response.data.allContacts.totalCount
      },
      () => this.fetchSequence(this.state.campaignContacts)
    );
  };

  onSearchClick = () => {
    if (this.state.searchFlag === true) {
      this.setState({ clickToSearch: true }, () => {
        this.child.current.searchFetch(this.state.limit, this.state.offset);
        this.ExportData();
      });
    } else {
      this.setState({ clickToSearch: false }, () => {
        this.child.current.searchFetch(this.state.limit, this.state.offset);
        this.ExportData();
      });
    }
  };

  debounce = (debounceTimer, func, delay) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(func, delay);
    return debounceTimer;
  };
  debounceTimer = null;
  handleSearchChange = event => {
    this.setState({
      search: event.target.value,
      searchFlag: true,
      isSearching: true
    });
    this.debounceTimer = this.debounce(
      this.debounceTimer,
      () => {
        this.onSearchClick();
        this.setState({ isSearching: false });
      },
      200
    );
  };

  onTableRowClick = rowInfo => {
    this.setState({ Row: rowInfo.original.id });
  };

  fetchContactDrawerDetails = (side, open, row) => event => {
    this.setState({ getData: [] });
    fetchMethod(contacts(row.id))
      .then(res => res.json())
      .then(res => {
        res.data.allContacts !== undefined
          ? this.setState({
            ContactDetailsWorkflow:
              res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null
                ? res.data.allContacts.Contacts[0].Contactworkflowhistoryfk
                  .Contactworkflowhistories
                : "",
            ContactDetailsMessages:
              res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null
                ? res.data.allContacts.Contacts[0].Contactmessagesfk
                  .Contactmessages
                : "",
            getData:
              res.data.allContacts !== undefined &&
                res.data.allContacts !== null
                ? res.data.allContacts.Contacts[0]
                : "",
            getCampaignId:
              res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null
                ? res.data.allContacts.Contacts[0].campaignid
                : "",
            getCampaignId2:
              res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null
                ? res.data.allContacts.Contacts[0].campaignid
                : "",

            getCustomer:
              res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null &&
                res.data.allContacts.Contacts[0].Campaigns.Campaigns.length > 0
                ? res.data.allContacts.Contacts[0].Campaigns.Campaigns[0]
                  .Customers.Customers[0]
                : "",
            contactStatus:
              res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null
                ? res.data.allContacts.Contacts[0].contactstatus
                : "",
            campaignStatus:
              res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null
                ? res.data.allContacts.Contacts[0].campaignstatus
                : "",
            contactId:
              res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null
                ? res.data.allContacts.Contacts[0].id
                : ""
          })
          : this.setState({ loading: true });
      })
      .catch(e => console.log(e));
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    this.setState({ ...this.state, [side]: open });
  };

  closeDetails = () => {
    this.setState({
      openDetails: false,
      getCampaignId: [],
      getCustomer: [],
      getData: [],
      contactStatus: null,
      campaignStatus: null
    });
  };

  clearFilters = () => {
    this.setState(
      {
        search: "",
        searchFlag: false,
        clickToSearch: false,
        limit: 50,
        offset: 50
      },
      () => {
        this.child.current.searchFetch(this.state.limit, this.state.offset);
        this.ExportData();
      }
    );
  };

  fetchRefresh = response => {
    this.fetchMessage(response);
  };
  fetchMessage = response => {
    fetchMethod(contacts(response))
      .then(res => res.json())
      .then(res => {
        res.data.allContacts !== undefined
          ? this.setState({
            ContactDetailsMessages:
              res.data.allContacts.Contacts[0] !== undefined &&
                res.data.allContacts.Contacts[0] !== null
                ? res.data.allContacts.Contacts[0].Contactmessagesfk
                  .Contactmessages
                : ""
          })
          : this.setState({ loading: true });
      })
      .catch(e => console.log(e));
  };
  onSearchKeyDown = event => {
    return event.key === "Enter" ? this.onSearchClick() : "";
  };

  formatDate = date => {
    if (date !== null && date !== undefined && date) {
      date = new Date(
        date
          .split("/")
          .reverse()
          .join("/")
      );
      let dd = date.getDate();
      let mm = date.getMonth() + 1;
      let yyyy = date.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      date = `${dd}/${mm}/${yyyy}`;
      return date;
    }
    return;
  };
  formatDate2 = date => {
    if (date !== null && date !== undefined && date) {
      date = new Date(
        date
          .split("/")
          .reverse()
          .join("/")
      );
      let dd = date.getDate();
      let mm = date.getMonth() + 1;
      let yyyy = date.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      date = `${mm}/${dd}/${yyyy}`;
      return date;
    }
    return;
  };
  fetchRefresh1 = response => {
    this.fetchName(response);
  };
  fetchName = response => {
    fetchMethod(contacts(response))
      .then(res => res.json())
      .then(res => {
        res.data.allContacts !== undefined
          ? this.setState({
            getData:
              res.data.allContacts !== undefined &&
                res.data.allContacts !== null
                ? res.data.allContacts.Contacts[0]
                : ""
          })
          : this.setState({ loading: true });
      })
      .catch(e => console.log(e));
  };

  gettingAllDataFromQuery = () => {
    const filter = this.filter();
    fetchMethod(campaignContactsTabSelectList, filter)
      .then(response => {
        return response.json();
      })
      .then(responseAsJson => {
        let allselectedIds = [];
        responseAsJson.data.allContacts.Contacts.map(i => {
          allselectedIds.push({ id: i.id });
        });
        this.setState(
          {
            campaignContactAllSelectedList: allselectedIds
          },
          () => {
            let selectedArr = [];
            let consolidateArray = [];
            this.state.campaignContactAllSelectedList.map(item => {
              consolidateArray[item.id] = true;
              selectedArr.push({ id: item.id });
            });
            this.setState({
              selectAll: true,
              selected: consolidateArray,
              selectedArray: selectedArr
            });
          }
        );
      })
      .catch(e => {
        console.log(e);
        this.setState({ loading: true });
      });
  };

  onRowSelected = sarray => {
    if (sarray.length === this.state.totalCount) {
      this.setState({ selectAll: true });
    } else {
      this.setState({ selectAll: false });
    }
  };

  toggleRowNew = (id, rowInfo) => {
    const newSelected = Object.assign({}, this.state.selected);
    newSelected[id] = !this.state.selected[id];
    this.setState({
      selected: newSelected
    });
    const { selectedArray } = this.state;
    let arr = selectedArray.filter(val => val.id !== id);
    if (!arr.length) {
      this.setState(
        {
          selectedArray: []
        },
        () => {
          this.onRowSelected(this.state.selectedArray);
        }
      );
    }
    if (arr.length === selectedArray.length) {
      this.setState(
        {
          selectedArray: [...selectedArray, rowInfo]
        },
        () => {
          this.onRowSelected(this.state.selectedArray);
        }
      );
    } else {
      this.setState(
        {
          selectedArray: arr
        },
        () => {
          this.onRowSelected(this.state.selectedArray);
        }
      );
    }
  };

  toggleSelectAllRow = isChecked => {
    if (isChecked) {
      this.gettingAllDataFromQuery();
    } else {
      this.setState({
        selectAll: false,
        selectedArray: [],
        selected: {}
      });
    }
  };

  NameFilter = () => {
    this.setState({ columnFilter: "name asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  NameFilter1 = () => {
    this.setState({ columnFilter: "name desc", shortfilter: false }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  CompanyFilter = () => {
    this.setState({ columnFilter: "organization asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  CompanyFilter1 = () => {
    this.setState(
      { columnFilter: "organization desc", shortfilter: false },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  PositionFilter = () => {
    this.setState({ columnFilter: "designation asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  PositionFilter1 = () => {
    this.setState(
      { columnFilter: "designation desc", shortfilter: false },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  LocationFilter = () => {
    this.setState({ columnFilter: "location asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  LocationFilter1 = () => {
    this.setState({ columnFilter: "location desc", shortfilter: false }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  connectedonFilter = () => {
    this.setState({ columnFilter: "connectedon asc", shortfilter: true }, () =>
      this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  connectedonFilter1 = () => {
    this.setState(
      { columnFilter: "connectedon desc", shortfilter: false },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  InvitationsentFilter = () => {
    this.setState(
      { columnFilter: "invitationsent asc", shortfilter: true },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  InvitationsentFilter1 = () => {
    this.setState(
      { columnFilter: "invitationsent desc", shortfilter: false },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  currentstatusFilter = () => {
    this.setState(
      { columnFilter: "currentstatus asc", shortfilter: true },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };

  currentstatusFilter1 = () => {
    this.setState(
      { columnFilter: "currentstatus desc", shortfilter: false },
      () => this.child.current.searchFetch(this.state.limit, this.state.offset)
    );
  };
  filter = () => {
    const Search = this.state.clickToSearch
      ? this.state.search.trim().replace(/\s\s+/g, " ")
      : "";
    const like = `%${Search}%`;
    const filterr = {
      where: {
        active: "1",
        open: "1",
        campaignid: this.props.campaignId,
        order: this.state.columnFilter,
        and: [
          {
            or: [
              { name: { like: like, options: "i" } },
              { location: { like: like, options: "i" } },
              { designation: { like: like, options: "i" } },
              { organization: { like: like, options: "i" } }
            ]
          }
        ]
      }
    };
    return filterr;
  };

  fetchSequence = async responsee => {
    let index = 0;
    responsee.map(async response => {
      if (
        response !== undefined &&
        response.currentStage !== undefined &&
        response.currentStage.Contactworkflowhistories !== undefined
      ) {
        let l = response.currentStage.Contactworkflowhistories.length - 1;
        let sequence = response.currentStage.Contactworkflowhistories[l];
        if (
          sequence &&
          sequence.contactworkflowhistoryIbfk2rel &&
          sequence.contactworkflowhistoryIbfk2rel.Campaignsteps[0] &&
          sequence.contactworkflowhistoryIbfk2rel &&
          sequence.contactworkflowhistoryIbfk2rel.Campaignsteps[0]
        ) {
          const plannedDateFilter = {
            where: {
              campaignid:
                sequence.contactworkflowhistoryIbfk2rel.Campaignsteps[0]
                  .campaignid,
              active: 1,
              sequence:
                sequence.contactworkflowhistoryIbfk2rel.Campaignsteps[0]
                  .sequence + 1
            }
          };

          response.currentStage.Contactworkflowhistories[
            l
          ].nextStep = undefined;
          await fetchMethod(plannedDate, plannedDateFilter)
            .then(res => res.json())
            .then(res => {
              if (
                res &&
                res.data &&
                res.data.allCampaignsteps &&
                res.data.allCampaignsteps.Campaignsteps.length > 0 &&
                res.data.allCampaignsteps.Campaignsteps[0]
              ) {
                let daysDelay =
                  res.data.allCampaignsteps.Campaignsteps[0].daysdelay;
                let NextStepName =
                  res.data.allCampaignsteps.Campaignsteps[0].stepname;
                if (
                  NextStepName === "SEND_THANKS_MESSAGE" &&
                  response.connectedon
                ) {
                  var Connectedon = "";
                  if (
                    response.thanksmsgdate == "" ||
                    response.thanksmsgdate == null
                  ) {
                    Connectedon = response.connectedon.split("/");
                  } else {
                    Connectedon = response.thanksmsgdate.split("/");
                  }
                  Connectedon =
                    Connectedon[2] +
                    "/" +
                    Connectedon[1] +
                    "/" +
                    Connectedon[0];
                  let date = new Date(Connectedon);
                  let someDate = new Date(date);

                  let addDate = 0;
                  if (
                    response.thanksmsgdate == "" ||
                    response.thanksmsgdate == null
                  ) {
                    addDate = daysDelay;
                  } else {
                    addDate = 0;
                  }

                  let dd1 = someDate.setDate(someDate.getDate() + addDate);

                  let oldDate = new Date(dd1);

                  let todayDate = new Date();

                  let diffTime = todayDate - oldDate;

                  let diffDays = diffTime / (1000 * 60 * 60 * 24);

                  if (diffDays >= 0) {
                    let Planndate = new Date(todayDate);

                    let dd = Planndate.getDate(dd1);
                    let mm = Planndate.getMonth() + 1;
                    let yyyy = Planndate.getFullYear();
                    if (dd < 10) {
                      dd = "0" + dd;
                    }
                    if (mm < 10) {
                      mm = "0" + mm;
                    }

                    Planndate = `${dd}/${mm}/${yyyy}`;

                    response.currentStage.Contactworkflowhistories[l].nextStep =
                      "Send Thanks Message" + " " + Planndate;
                  } else if (diffDays < 0) {
                    let Planndate = new Date(oldDate);

                    let dd = Planndate.getDate(dd1);
                    let mm = Planndate.getMonth() + 1;
                    let yyyy = Planndate.getFullYear();
                    if (dd < 10) {
                      dd = "0" + dd;
                    }
                    if (mm < 10) {
                      mm = "0" + mm;
                    }

                    Planndate = `${dd}/${mm}/${yyyy}`;
                    response.currentStage.Contactworkflowhistories[l].nextStep =
                      "Send Thanks Message" + " " + Planndate;
                  } else {
                    response.currentStage.Contactworkflowhistories[l].nextStep =
                      "Send Thanks Message" + " " + date;
                  }
                } else if (NextStepName !== "SEND_THANKS_MESSAGE") {
                  var current_date = "";
                  var addDay = 0;
                  if (sequence.nextstep == null || sequence.nextstep == "") {
                    current_date = sequence.executedon;
                    addDay = daysDelay;
                  } else {
                    current_date = sequence.nextstep;
                    addDay = 0;
                  }

                  var someDate = new Date(current_date);

                  current_date = someDate.setDate(someDate.getDate() + addDay);
                  let oldDate = new Date(current_date).getTime();
                  let todayDate = new Date().getTime();

                  let difference = todayDate - oldDate;
                  let diffDays = difference / (1000 * 3600 * 24);

                  if (diffDays >= 0) {
                    let date = moment(todayDate)

                      .toDate();
                    let current_date1 = new Date(date);
                    let utc =
                      current_date1.getTime() +
                      current_date1.getTimezoneOffset() * 60000;
                    let offset_time = new Date(utc + 3600000 * 5.5);
                    let planDate = moment(offset_time).format("DD/MM/YYYY");
                    response.currentStage.Contactworkflowhistories[l].nextStep =
                      NextStepName === "SEND_INVITE"
                        ? "Send Invite"
                        : NextStepName === "FOLLOW"
                          ? "Follow"
                          : NextStepName === "VISIT"
                            ? "Visit"
                            : "Send Message" + " " + planDate;
                  } else if (diffDays < 0) {
                    let date = moment(oldDate)

                      .toDate();

                    let current_date1 = new Date(date);
                    let utc =
                      current_date1.getTime() +
                      current_date1.getTimezoneOffset() * 60000;
                    let offset_time = new Date(utc + 3600000 * 5.5);
                    let planDate = moment(offset_time).format("DD/MM/YYYY");

                    response.currentStage.Contactworkflowhistories[l].nextStep =
                      NextStepName === "SEND_INVITE"
                        ? "Send Invite"
                        : NextStepName === "FOLLOW"
                          ? "Follow"
                          : NextStepName === "VISIT"
                            ? "Visit"
                            : "Send Message" + " " + planDate;
                  } else {
                    let date = moment(current_date)
                      .add(daysDelay, "days")
                      .toDate();
                    let current_date1 = new Date(date);
                    var utc =
                      current_date1.getTime() +
                      current_date1.getTimezoneOffset() * 60000;
                    var offset_time = new Date(utc + 3600000 * 5.5);
                    var date1 = moment(offset_time).format("DD/MM/YYYY");

                    response.currentStage.Contactworkflowhistories[l].nextStep =
                      NextStepName === "SEND_INVITE"
                        ? "Send Invite"
                        : NextStepName === "FOLLOW"
                          ? "Follow"
                          : NextStepName === "VISIT"
                            ? "Visit"
                            : "Send Message" + " " + date1;
                  }
                }
              }
            })
            .catch(e => console.log(e));
        }
      }
      index++;
      if (index === responsee.length && this.state.totalCount !== 0) {
        this.setState({ campaignContacts: responsee });
      }
    });
  };
  formatDate3 = date => {
    if (date !== null && date !== undefined && date) {
      date = new Date(date);
      let dd = date.getDate();
      let mm = date.getMonth() + 1;
      let yyyy = date.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      date = `${dd}/${mm}/${yyyy}`;
      return date;
    }

    return;
  };
  handleStatusChange2 = (row, updateStatus, date) => event => {
    updateStatus = {
      where: { id: row.original.id },
      data: {
        followup: this.formatDate3(event)
      }
    };

    swal({
      title: "Are you sure want to convert?",
      icon: "warning",
      buttons: true,
      dangerMode: true
    }).then(willConvert => {
      if (willConvert) {
        fetchMethod(UpdatefollowUp, updateStatus)
          .then(response => {
            return response.json();
          })
          .then(res => {
            if (res.data.ContactsUpsertWithWhere) {
              swal("Successfully updated", { icon: "success" }).then(() => {
                this.child.current.searchFetch(
                  this.state.limit,
                  this.state.offset
                );
              });
            } else swal("Error", { icon: "error" });
          })

          .catch(err => {
            console.log(err);
            swal("Error", { icon: "error" });
          });
      }
    });
  };
  showEngagedToPopup = row => e => {
    this.setState({
      selectedEngagedRow: {
        ...row,

        anchorEl: e.currentTarget
      },
      clientY: e.clientY,
      clientX: e.clientX
    });
  };
  onCloseEngagedPopup = () => {
    this.setState({ selectedEngagedRow: null });
  };

  render() {
    //filter
    const campaignContacts = [...this.state.campaignContacts];
    //cons
    const { selectedEngagedRow } = this.state;
    const campaignContactsExportData = [
      ...this.state.campaignContactsExportData
    ];
    const CampaignContactsListHeaders = [
      {
        Header: obj => {
          return (
            <Checkbox
              defaultChecked
              size="small"
              value="small"
              color="primary"
              style="thick"
              inputProps={{ "aria-label": "checkbox with small size" }}
              checked={this.state.selectAll}
              onChange={e => {
                this.toggleSelectAllRow(e.target.checked);
              }}
            />
          );
        },
        width: 38,
        Cell: rowInfo => {
          return (
            <Checkbox
              defaultChecked
              size="small"
              value="small"
              color="primary"
              style="thick"
              inputProps={{ "aria-label": "checkbox with small size" }}
              checked={this.state.selected[rowInfo.original.id] === true}
              onChange={() =>
                this.toggleRowNew(rowInfo.original.id, rowInfo.original)
              }
            />
          );
        }
      },
      {
        Header: "Image",
        accessor: "Image",
        width: 70
      },
      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{
                cursor: "pointer"
              }}
              onClick={
                this.state.shortfilter !== true
                  ? this.NameFilter
                  : this.NameFilter1
              }
            >
              Name
            </div>
          );
        },
        accessor: "Name",
        width: 150,
        Cell: row => (
          <div
            style={{ cursor: "pointer", color: "#2BADDD" }}
            onClick={this.fetchContactDrawerDetails(
              "openDetails",
              true,
              row.original
            )}
          >
            {row.original.name}
          </div>
        )
      },
      {
        Header: "First Name",
        accessor: "fname"
      },
      {
        Header: obj => {
          return (
            <div
              style={{
                cursor: "pointer"
              }}
              onClick={
                this.state.shortfilter !== true
                  ? this.CompanyFilter
                  : this.CompanyFilter1
              }
            >
              Current Company
            </div>
          );
        },
        accessor: "organization",
        width: 150,
      },
      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{
                cursor: "pointer"
              }}
              onClick={
                this.state.shortfilter !== true
                  ? this.PositionFilter
                  : this.PositionFilter1
              }
            >
              Current Position
            </div>
          );
        },
        accessor: "designation",
        width: 150,
      },
      {
        Header: obj => {
          return (
            <div
              style={{
                cursor: "pointer"
              }}
              onClick={
                this.state.shortfilter !== true
                  ? this.LocationFilter
                  : this.LocationFilter1
              }
            >
              Location
            </div>
          );
        },
        accessor: "location",
        width: 150,
      },

      {
        Header: obj => {
          return (
            <div
              style={{
                cursor: "pointer"
              }}
              onClick={
                this.state.shortfilter !== true
                  ? this.connectedonFilter
                  : this.connectedonFilter1
              }
            >
              Connected On
            </div>
          );
        },
        accessor: "Connectedon",
        width: 110,
      },
      {
        Header: obj => {
          return (
            <div
              style={{
                cursor: "pointer"
              }}
              onClick={
                this.state.shortfilter !== true
                  ? this.InvitationsentFilter
                  : this.InvitationsentFilter1
              }
            >
              Invitation Sent
            </div>
          );
        },
        accessor: "InvitationSent",
        width: 110,
      },

      {
        Header: obj => {
          return (
            <div
              style={{
                cursor: "pointer"
              }}
              onClick={
                this.state.shortfilter !== true
                  ? this.currentstatusFilter
                  : this.currentstatusFilter1
              }
            >
              Current Stage
            </div>
          );
        },
        accessor: "CurrentStage"
      },

      {
        Header: "Last Response",
        accessor: "LR",
        width: 110,
      },

      {
        Header: obj => {
          return (
            <div
              className="Name"
              style={{
                cursor: "pointer"
              }}
            >
              Follow Up
            </div>
          );
        },
        accessor: "followup",

        Cell: row => {
          return (
            <div
              className="iconButton"
              style={{
                color: row.original.followup2 == 1 ? "#FFBF00" : "red"
              }}
            >
              {row.original.followup}

              <span className="EditIcon">
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <KeyboardDatePicker
                    margin="normal"
                    id="date-picker-dialog"
                    format="dd/MM/yyyy"
                    value=""

                    onChange={this.handleStatusChange2(row)}
                    keyboardIcon={
                      <img src={editicon} alt="" style={{ width: "17px" }} />
                    }
                    InputProps={{
                      disableUnderline: true
                    }}
                    helperText={""}
                  />
                </MuiPickersUtilsProvider>
              </span>
            </div>
          );
        }
      },
      {
        Header: " Status",
        accessor: "CampaignStatus"
      },
      {
        Header: "",
        Cell: row => {
          return (
            <div className="iconButton">
              {localStorage.getItem("role") !== "CUSTOMER" ? (
                <IconButton
                  aria-haspopup="true"
                  onClick={this.showEngagedToPopup(row)}
                >
                  <MoreVertIcon />
                </IconButton>
              ) : (
                ""
              )}
            </div>
          );
        }
      }
    ];

    campaignContacts.map(list => {
      if (
        list.lastresponse !== undefined &&
        list.lastresponse !== null &&
        list.lastresponse
      ) {
        list.LR = this.formatDate(list.lastresponse.split("T")[0]);
      }

      if (
        list.followup !== undefined &&
        list.followup !== null &&
        list.followup !== "" &&
        list.followup
      ) {
        var date = this.formatDate2(list.followup.split("T")[0]);
        var cmTime = new Date(date);
        var dateday = cmTime.getDay();
        if (dateday >= 3) {

          var lastDay = cmTime;
          lastDay.setDate(cmTime.getDate() + 5);
          var today = new Date();
          if (lastDay > today) {
            list.followup2 = 1;
          } else {
            list.followup2 = 0;
          }
        } else {

          var lastDay = cmTime;
          lastDay.setDate(cmTime.getDate() + 3);
          var today = new Date();
          if (lastDay > today) {
            list.followup2 = 1;
          } else {
            list.followup2 = 0;
          }
        }
      }

      if (
        list.followup !== undefined &&
        list.followup !== null &&
        list.followup
      ) {
        list.followup = this.formatDate(list.followup.split("T")[0]);
      }
      let image =
        list.profileimage !== undefined && list.profileimage !== null
          ? list.profileimage.substr(0, 5)
          : "";
      let imageSourceUrl = getContactImageUrl;
      if (image === "https") {
        if (list.id > 917500) {
          imageSourceUrl = getContactImageUrl2;
        }
        list.Image = (
          <div
            style={{ cursor: "pointer" }}
            onClick={this.fetchContactDrawerDetails("openDetails", true, list)}
          >
            <img
              src={list.profileimage}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null; // prevents looping
                currentTarget.src = imageSourceUrl.url + list.image;
              }}
              style={{ borderRadius: "50%", width: "30px" }}
            />
          </div>
        );
      } else {
        list.Image = (
          <div
            style={{ cursor: "pointer" }}
            onClick={this.fetchContactDrawerDetails("openDetails", true, list)}
          >
            <img
              src={imageSourceUrl.url + list.image}
              style={{ borderRadius: "50%", width: "30px" }}
            />
          </div>
        );
      }

      list.CampaignStatus =
        list.campaignstatus !== null && list.campaignstatus !== undefined
          ? list.campaignstatus === "COMPLETED"
            ? "Completed"
            : list.campaignstatus === "PAUSE"
              ? "Pause"
              : "Live"
          : "";

      if (
        list.connectedon !== undefined &&
        list.connectedon !== null &&
        list.connectedon
      ) {
        list.Connectedon = this.formatDate(list.connectedon);
      }

      if (
        list.invitationsent !== undefined &&
        list.invitationsent !== null &&
        list.invitationsent
      ) {
        list.InvitationSent = this.formatDate(
          list.invitationsent.split("T")[0]
        );
      }

      if (
        list.currentstatus !== undefined &&
        list.currentstatus !== null &&
        list.currentstatus
      ) {
        list.CurrentStage = list.currentstatus;
      }

      if (
        list.currentstatus !== undefined &&
        list.currentstatus !== null &&
        list.currentstatus
      ) {
        if (
          list.invitesent == 0 &&
          (list.currentstatus == "Invite Sent" ||
            list.currentstatus == "Invite Not Sent")
        ) {
          list.CurrentStage = "Invite not Sent";
        } else {
          list.CurrentStage = list.currentstatus;
        }
      }

      return null;
    });

    campaignContactsExportData.map(list => {
      if (
        list.lastresponse !== undefined &&
        list.lastresponse !== null &&
        list.lastresponse
      ) {
        list.LR = list.lastresponse;
      }
      if (
        list.invitationsent !== undefined &&
        list.invitationsent !== null &&
        list.invitationsent
      ) {
        list.InvitationSent = list.invitationsent.split("T")[0];
      }
      if (
        list.currentstatus !== undefined &&
        list.currentstatus !== null &&
        list.currentstatus
      ) {
        list.CurrentStage = list.currentstatus;
      }
    });

    const filter = this.filter();

    return (
      <div className="CampaignContactsTab">
        <div className="CampaignContactsHeader">
          <div className="CampaignContactsLeftFilters">
            <Drawer
              anchor="right"
              open={this.state.openDetails}
              onClose={() => this.closeDetails()}
            >
              <ContactDetails
                onSearchClick={this.onSearchClick}
                refreshMessage1={this.fetchRefresh1}
                refreshMessage={this.fetchRefresh}
                Close={() => this.closeDetails()}
                details={this.state.getData}
                Campaignid={this.state.getCampaignId2}
                Customer={this.state.getCustomer}
                contactStatus={this.state.contactStatus}
                campaignStatus={this.state.campaignStatus}
                id={this.state.contactId}
                tableRerender={this.child.current}
                limit={this.state.limit}
                offset={this.state.offset}
                ContactDetailsWorkflow={this.state.ContactDetailsWorkflow}
                ContactDetailsMessages={this.state.ContactDetailsMessages}
                heading={"Contact Details"}
              />
            </Drawer>

            <div className="searchContact">
              <TextField
                id="outlined-search"
                label="Search"
                placeholder="Company/name/position/location"

                margin="normal"
                variant="outlined"
                value={this.state.search}
                onChange={this.handleSearchChange}
                onKeyDown={this.onSearchKeyDown}
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  endAdornment: (
                    <img
                      src={SearchIcon}
                      style={{ width: "15px", cursor: "pointer" }}
                      onClick={() => this.onSearchClick()}
                    />
                  )
                }}
              />
            </div>

            <div className="CampaignContactsButton">
              <Button className="button" onClick={this.clearFilters}>
                <span style={{ textTransform: "capitalize" }}> Reset All</span>
              </Button>
            </div>
            {selectedEngagedRow && (
              <NoOppTo
                target={selectedEngagedRow && selectedEngagedRow.anchorEl}
                contactStatus={selectedEngagedRow.original.contactstatus}
                campaignStatus={selectedEngagedRow.original.campaignstatus}
                id={selectedEngagedRow.original.id}
                tableRerender={this.child.current}
                clientY={this.state.clientY}
                clientX={this.state.clientX}
                limit={this.state.limit}
                offset={this.state.offset}
                onClose={this.onCloseEngagedPopup}
              />
            )}

            <div
              style={{
                marginRight: "0px",
                marginLeft: "auto"
              }}
            >
              <p
                style={{
                  color: "#36454d",
                  fontSize: "15px"
                }}
              >
                Total Records: <span>{this.state.totalCount}</span>
              </p>
            </div>

            <div className="RightContext">
              <ExportTo
                fileData={campaignContactsExportData}
                ContactDetailsMessages={this.state.ContactDetailsMessages}
                SalesHubdata={this.state.selectedArray}
                Profile={this.state.profileid}
                selectedArray={this.emptySelectedArray}
                SalesforceToken={this.state.salesforcetoken}
                HubspotToken={this.state.hubspottoken}
              />
            </div>

          </div>

        </div>
        <ReactTableComponent
          ref={this.child}
          listData={this.state.campaignContacts}
          listConfig={CampaignContactsListHeaders}
          setData={this.setContactsListData}
          query={campaignContactsTabList}
          totalCount={this.state.totalCount}
          setLimit={this.SetLimit}
          setOffset={this.SetOffset}
          filter={filter}
          clickToSearch={this.state.clickToSearch}
          onRowClick={this.onTableRowClick}
        />
      </div>
    );
  }
}
export default CampaignContactsTab;
